import React from 'react';

// interface
import { ILinkedIconModuleProps, ILinkProps } from '../../../interfaces/interfaces';

// module, source
import Header from '../../elements/Header/Header';
import Link from '../../elements/Link/Link';
import { ModalContextConsumer } from '../../../contexts/modalContext';
import TileWrapper from '../../elements/TileWrapper/TileWrapper';
import ModalHelpers from '../../../helpers/ModalHelpers/ModalHelpers';

function AppStoreModule(props: ILinkedIconModuleProps & ILinkProps): JSX.Element {
  const { headline, linkText, tileId, iconUrl } = props;

  return (
    <>
      {headline ? <Header headline={headline} tileId={tileId} isLight /> : ''}
      <TileWrapper className="tile-padding" clickable>
        <div className="icon">
          <img src={iconUrl} alt="NO ICON"/>
        </div>

        <ModalContextConsumer>
          {({ openModal }) => (
            <Link
              onClick={() => {
                ModalHelpers.openAppStore(openModal);
              }}
              linkText={linkText}
              linkClass="tile-link link ic-arrowRight"
              linkTextClass="link-text"
            />
          )}
        </ModalContextConsumer>
      </TileWrapper>
    </>
  );
}
export default AppStoreModule;
